import script from "./ScrollToTmp.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScrollToTmp.vue?vue&type=script&lang=ts&setup=true"

import "./ScrollToTmp.vue?vue&type=style&index=0&id=6dd4e9c0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dd4e9c0"]])

export default __exports__